export const LIST_CATEGORIES = '/domain/option-categories?pmEncodedBusinessName='
export const LIST_OPTIONS = '/domain/option-categories/:id?pmEncodedBusinessName='
export const LIST_HIGH_GROUPS = '/domain/component-high-groups?pmEncodedBusinessName='
export const LIST_COMPONENTS = '/domain/component-high-groups/:id?pmEncodedBusinessName='
